import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorFeeDiscountTaker = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M9.075 12.15c-.435 0-.806-.154-1.114-.461a1.518 1.518 0 0 1-.461-1.114c0-.435.154-.806.461-1.114A1.518 1.518 0 0 1 9.075 9c.435 0 .806.154 1.114.461.307.308.461.679.461 1.114 0 .435-.154.806-.461 1.114a1.518 1.518 0 0 1-1.114.461Zm0-.9a.65.65 0 0 0 .478-.197.65.65 0 0 0 .197-.478.65.65 0 0 0-.197-.478.65.65 0 0 0-.478-.197.65.65 0 0 0-.478.197.65.65 0 0 0-.197.478.65.65 0 0 0 .197.478.65.65 0 0 0 .478.197Zm4.05 4.95c-.435 0-.806-.154-1.114-.461a1.518 1.518 0 0 1-.461-1.114c0-.435.154-.806.461-1.114a1.517 1.517 0 0 1 1.114-.461c.435 0 .806.154 1.114.461.307.308.461.679.461 1.114 0 .435-.154.806-.461 1.114a1.518 1.518 0 0 1-1.114.461Zm0-.9a.65.65 0 0 0 .478-.197.65.65 0 0 0 .197-.478.65.65 0 0 0-.197-.478.65.65 0 0 0-.478-.197.65.65 0 0 0-.478.197.65.65 0 0 0-.197.478.65.65 0 0 0 .197.478.65.65 0 0 0 .478.197Zm-4.995.9-.63-.63L14.07 9l.63.63-6.57 6.57Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M11.5 4.75a7.25 7.25 0 1 0 6.28 10.874.75.75 0 1 1 1.299.751 8.75 8.75 0 1 1-2.11-11.206.75.75 0 1 1-.938 1.17A7.216 7.216 0 0 0 11.5 4.75Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M17.97 8.47a.75.75 0 0 1 1.06 0l2 2a.75.75 0 1 1-1.06 1.06l-1.47-1.47-1.47 1.47a.75.75 0 1 1-1.06-1.06l2-2Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M18.5 8.25a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="m21.75 6 .008.06c.049.378.36.668.742.69l-.029.005a.895.895 0 0 0-.721.745.834.834 0 0 0-.682-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
    />
  </svg>
);
export default SvgTwoColorFeeDiscountTaker;
